module.exports = "<ul class=\"tab-navigation\">\n\t<ng-container *ngFor=\"let tab of tabs\">\n\t\t<li *ngIf=\"!tab.requiredRole || roleIsCorrect(tab.requiredRole)\"\n\t\t\t(click)=\"selectTab(tab)\" [ngClass]=\"{'tab-navigation__tab--active':tab.active,'tab-navigation__tab--inactive': !tab.active, 'tab-navigation__tab--disabled': tab.disabled}\"\n\t\t>\n\t\t\t<a class=\"tab-navigation__link\">{{tab.title}}</a>\n\t\t</li>\n\t</ng-container>\n</ul>\n\n<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/tabs/tabs.html
// module id = zD7J
// module chunks = 12